"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Fallback = function (props) { return (React.createElement("div", { style: __assign({ position: 'absolute', width: '100%', height: '100%', left: 0, top: 0, background: '#f3f3f3' }, (props.style)) })); };
exports.default = Fallback;
//# sourceMappingURL=Fallback.js.map